import { render, staticRenderFns } from "./UpdatePersonalData.vue?vue&type=template&id=4e9bc006"
import script from "./UpdatePersonalData.vue?vue&type=script&lang=js"
export * from "./UpdatePersonalData.vue?vue&type=script&lang=js"
import style0 from "./UpdatePersonalData.vue?vue&type=style&index=0&id=4e9bc006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports